<form #dismissForm="ngForm" (ngSubmit)="dismiss()" novalidate>
  <h2 mat-dialog-title>Dismiss Max Mismatches Warning</h2>
  <mat-dialog-content>
    <div class="participant-info">
      <div class="row">
        <span class="label">Recipient:</span>
        <span class="value">{{ recipient.enisNumber }}</span>
        <span class="flex">{{ recipient.firstName || "" }} {{ recipient.lastName || "" }}</span>
      </div>
    </div>

    <p>
      This recipient has max mismatches privilege but they are not part of a compatible pair or younger than 18 years old.
      Please provide a reason for dismissing this warning after consultation with the center.
    </p>

    <mat-form-field>
      <textarea
        matInput
        name="dismissalReason"
        rows="3"
        required
        placeholder="Reason for dismissing warning (after consultation with center)"
        [(ngModel)]="dismissalReason"
        #reasonCtrl="ngModel"
      ></textarea>
      <mat-error *ngIf="reasonCtrl.hasError('required')">
        Please enter a reason for dismissing the warning.
      </mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="spacer"></div>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button type="submit" [disabled]="!isFormValid()">Dismiss Warning</button>
  </mat-dialog-actions>
</form>
